const APPSFLYER_ONELINK = "https://app.refluenced.com/sTNL/ref";
const APPSFLYER_OPEN_CAMPAIGN_LINK = "https://app.refluenced.com/sTNL/open_campaign";

export const getAppDownloadLink = ({referralCode}: {referralCode: string}) =>
  referralCode ? `${APPSFLYER_ONELINK}?referralcode=${referralCode}` : APPSFLYER_ONELINK;

export const getOpenCampaignLink = ({campaignId, currency}: {campaignId: number; currency: string}) =>
  `${APPSFLYER_OPEN_CAMPAIGN_LINK}?campaign_id=${campaignId}&currency=${currency}`;
